module.exports = __webpack_public_path__ + "components/flag/static/square/gi-ccb230610b1baa390dee8611c30b0f78.svg";